/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903853583 — Знижки */

import { useEffect, useMemo } from 'react';
import { useAppStore } from '../../../shared/hooks/useAppStore';
import { debug, getVmDetails } from '../../../shared/lib/general';
import {
    calculateDiscountedAmount,
    roundSubunitsForPayment,
} from '../payment.utils';
import { useSetOrderAmount } from './useSetOrderAmount';

export function usePopcornAmount() {
    const vm = useAppStore((store) => store.vm);
    const order = useAppStore((store) => store.order);
    const updateOrder = useAppStore((store) => store.updateOrder);
    const { mutate: setOrderAmountMutate } = useSetOrderAmount();

    // Planogram price is pre-discount; FE applies the discount before
    // submitting so order.amount reflects what the user actually pays.
    const popcornOriginalAmountCurrency = vm?.planogram?.[0]?.price ?? 0;

    const popcornDiscountedSubunits = useMemo(
        () =>
            roundSubunitsForPayment(
                calculateDiscountedAmount(
                    popcornOriginalAmountCurrency,
                    vm?.campaign?.discount_percentage,
                ),
            ),
        [popcornOriginalAmountCurrency, vm?.campaign?.discount_percentage],
    );

    const onOrderAmountChange = (orderId: string) => {
        setOrderAmountMutate(
            { orderId, amount: popcornDiscountedSubunits },
            {
                onSuccess: ({ skipped }) => {
                    if (skipped) return;
                    updateOrder((prev) => ({
                        ...prev,
                        amount: popcornDiscountedSubunits,
                    }));
                },
            },
        );
    };

    // Submit the popcorn amount once the order id is available.
    useEffect(() => {
        const { isPopcorn } = getVmDetails(vm);

        if (order.id && isPopcorn) {
            debug('inside useEffect:', 'data', {
                orderId: order?.id,
                order,
                vmOrder: order,
            });
            onOrderAmountChange(order.id);
        }
    }, [order.id, vm.type_id]);

    return { popcornOriginalAmountCurrency, popcornDiscountedSubunits };
}
